import { FragmentOf, ResultOf } from 'gql.tada';
import { gql } from '../../gql';

export const MY_PROFILE = gql(`
  fragment MyProfile on Profile {
    id
    type
    name
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
    contactAddressId
    contactAddress {
      id
      street1
      street1
      city
      state
      zip
    }
    billingAddressId
    billingAddress {
      id
      street1
      street1
      city
      state
      zip
    }
    phones {
      id
      subType
      value
    }
    emails {
      id
      subType
      value
    }
    perms
    user {
      profileId
      email
    }
  }
`);

export const COMPANY_CREDENTIALS = gql(`
  fragment CompanyCredentials on Credential {
    id
    type
    issuer
    value
    city
    state
    issueDate
    expireDate
    isDefault
    created
    updated
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const STRIPE_PAYMENT_METHOD = gql(`
  fragment StripePaymentMethod on StripePaymentMethod {
    id
    type
    # Card fields
    brand
    expMonth
    expYear
    last4
    # US Bank Account fields
    bankName
    accountHolderType
    accountType
    routingNumber
  }
`);

export const GET_MY_COMPANY_PROFILE = gql(
  `
    query GetMyProfile {
    me {
      ...MyProfile
      credentials(where: { type: "BUSINESS_LICENSE", archived: null }) {
        ...CompanyCredentials
      }
    }
    stripePlatformCustomer {
      defaultPaymentMethod {
        ...StripePaymentMethod
      }
    }
  }
  `,
  [MY_PROFILE, COMPANY_CREDENTIALS, STRIPE_PAYMENT_METHOD]
);

export type MyProfileFragment = FragmentOf<typeof MY_PROFILE>;
export type CompanyCredentialsFragment = FragmentOf<typeof COMPANY_CREDENTIALS>;
export type StripePaymentMethodFragment = FragmentOf<
  typeof STRIPE_PAYMENT_METHOD
>;

export type GetMyProfileResult = ResultOf<typeof GET_MY_COMPANY_PROFILE>;
